export const ko = {
  Global: {
    save: '저장',
    savingInProgress: 'Saving in progress KO',
    edit: '편집하다',
    amend: 'Amend KO',
    editProposal: 'Edit proposal KO',
    delete: '지우다',
    cancel: '취소',
    confirm: '확인',
    proceed: '발생하다',
    assign: '양수인',
    submit: '제출',
    accepted: '인정됨',
    denied: '거부됨',
    deny: '거부',
    comment: '논평',
    done: '끝난',
    notDone: '미완료',
    started: '시작된',
    notRelevant: '무관',
    noInfo: '정보 없음',
    addComment: '의견 추가',
    noComments: '코멘트가 없습니다',
    start: '시작',
    end: '종료',
    pending: '대기 중',
    approve: '승인',
    approved: '승인됨',
    notApproved: '승인이 거절 됨',
    release: '해제',
    released: '해제됨',
    notReleased: '미공개',
    reopen: '다시 열다',
    requestedBy: '에 의해 요청',
    requestedAt: '요청',
    proposedDecision: '제안 된 결정',
    proposedCategory: '제안 된 카테고리',
    proposedSubcategory: 'Proposed subcategory',
    search: '검색',
    noResults: '결과가 없습니다',
    upload: '업로드',
    uploading: '업로드 중',
    noFilesUploaded: '파일이 업로드되지 않았습니다',
    close: '닫기',
    back: '이전',
    next: '다음',
    unknown: '알 수 없는',
    from: '...에서',
    to: '에',
    logout: '로그 아웃',
    profile: '프로필',
    group: '그룹',
    code: '코드',
    confirmationDialogTitle: '확인 필요',
    confirmDeleteFileDialogContent: '이 파일을 삭제 하시겠습니까?',
    report: '보고서',
    unsavedAnswers: '저장되지 않은 답변이 있습니다. 확인하지 않으면 저장하지 않은 모든 데이터가 손실됩니다',
    unsavedAnswersActionMode: '저장되지 않은 답변이 있습니다. 저장 하시겠습니까?',
    noOptions: '옵션이 없습니다',
    actionMode: '동작 모드',
    reason: '이유',
    optional: '선택 과목',
    choose: '선택하다',
    serialNumberMissing: 'Serial number missing KO',
    recipientEmails: 'Recipient Emails (one address per line) KO',
    DatePicker: {
      cancelLabel: '취소',
      okLabel: '확인',
      minDateMessage: '날짜는 최소 날짜 이전이 아니어야합니다',
      maxDateMessage: '날짜는 최대 날짜 이후가 아니어야합니다',
      invalidDateMessage: '유효하지 않은 날짜 형식',
    },
    Errors: {
      authErrorTitle: '인증 오류',
      authErrorParagraph1: '이 앱에 액세스 할 권한이 없습니다',
      authErrorParagraph2: '관리자에게 문의하십시오',
      authErrorParagraph3: '또는 Active Directory에서 로그 아웃 한 후 다시 시도하십시오.',
      pageNotFound: '페이지를 찾을 수 없습니다',
      pageNotFoundParagraph1: '이 페이지를 찾을 수 없습니다',
      back: '홈',
      rotateDevice: '장치를 회전하십시오',
    },
    Feedback: {
      error: '문제가 발생했습니다 ... 작업이 실패했습니다',
      authentication: '인증 중 ... 잠시만 기다려주십시오',
      success: '작업이 성공적으로 완료되었습니다',
      limitReached: '상업적 결정 한계에 도달O',
      requestHasBeenSentToApprover: '요청이 승인자에게 전송되었습니다',
      noQuestions: '선택된 제품군에 대한 질문이 없습니다',
      decisionNotSend: '결정이 SAP에 성공적으로 전송되지 않았습니다.',
      noLimitForCC: '이 고객 센터에 대한 상업적 제한이 설정되어 있지 않습니다',
      jobCostDoesNotExist:'SAP 작업의 작업 비용이 PARS 데이터베이스에 없습니다.',
      materialNumberBrandDoesNotExist: '소재 번호 브랜드가 없습니다.',
      jobIsLocked: '작업이 잠겨 있습니다.',
      noPicturesAreUploaded: '업로드 된 사진이 없습니다.',
      rateIsProvided: '요금이 성공적으로 등록되었습니다',
      rateHasToBeDifferent: '요금 결정은 이전 결정과 달라야합니다.',
    },
    Status: {
      title: '상태',
      awaitingEquipment: '작업 대기',
      equipmentReceivedWithDocumentation: '설명서와 함께 제공된 장비',
      jobReleased: '일이 공개됨',
      productEvaluation: '평가 된 제품',
      strippedAndDecontaminated: '제거 및 오염 제거',
      builtAndTested: '구축 및 테스트',
      shipped: '배송 됨',
      technicalAndCommercialDecision: '기술 및 상업적 결정O',
      finalReportReleased: '최종 보고서 발표',
      closed: '닫음',
      productInvestigation: '제품 조사',
      customerHold: '고객 보류',
      notStarted: '시작되지 않음',
    },
    Roles: {
      RECEIVING: '전수',
      SERVICE_ENGINEER: '서비스 엔지니어',
      FAILURE_ANALYSIS_ENGINEER: '고장 분석 엔지니어',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: '선임 고장 분석 엔지니어',
      FAILURE_ANALYSIS_MANAGER: '고장 분석 관리자',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: '서비스 기술 센터 관리자',
      QUALITY_MANAGER: '품질 관리자',
      SERVICE_TECHNICAL_SUPPORT_TEAM: '서비스 기술 지원 팀',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: '제품 회사 기술 지원 팀',
      DIVISION_OR_BUSINESS_AREA: '사업부 또는 사업 영역O',
      CUSTOMER_CENTER: '고객 센터',
      CUSTOMER: '고객',
      CUSTOMER_CENTER_SERVICE_ENGINEER: '고객 센터 서비스 엔지니어',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer KO',
      SUPERADMIN: '최고 관리자',
      ZONE_LEADER: '존 리더',
      QUESTION_ADMIN: '질문 관리자',
      DISTRIBUTOR: '유통 업체',
    },
    Permissions: {
      VIEW_JOB: '작업 보기',
      EDIT_JOB: '작업 수정',
      IMPORT_JOB_FROM_SAP: 'SAP에서 작업 가져 오기',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: '조사를위한 레벨 3 공개',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: '조사를위한 레벨 4 공개',
      GENERATE_AND_DOWNLOAD_REPORT: '보고서 생성 및 다운로드',
      VIEW_LOG: '로그보기',
      VIEW_CONVERSATION: '대화보기',
      PARTICIPATE_IN_CONVERSATION: '대화에 참여',
      TAG_INTEREST: '관심 분야 태그',
      ADD_REMOVE_FROM_TEAM: '팀에서 추가 및 제거',
      CREATE_JOB: '작업 만들기',
      DELETE_JOB: '작업 삭제',
      REQUEST_DIFFERENT_REPORT_LEVEL: '다른 보고서 수준 요청',
      APPROVE_DIFFERENT_REPORT_LEVEL: '다른 보고서 수준 승인',
      WARRANTY_DECISION: '보증 결정',
      GOODWILL_DECISION: '영업권 결정',
      LEVEL_1_REPORT_APPROVAL: '레벨 1 보고서 승인',
      LEVEL_2_REPORT_APPROVAL: '레벨 2 보고서 승인',
      LEVEL_3_REPORT_APPROVAL: '레벨 3 보고서 승인',
      LEVEL_4_REPORT_APPROVAL: '레벨 4 보고서 승인',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen KO',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen KO',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen KO',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen KO',
      REOPEN_REPORT: '보고서 다시 열기',
      REQUEST_FAILED_PARTS: '고장난 부품 요청',
      SHIP_FAILED_PARTS: '배송 실패 부품',
      PRINT_INPUT_SHEETS: '입력 시트 인쇄',
      ADMINISTRATE_QUESTIONS: '질문 관리',
      ADMINISTRATE_DATA: '데이터 관리',
      DOWNLOAD_PICTURES: 'Download pictures KO',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission KO',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision KO',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision KO',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code KO',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category KO',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade KO',
    },
    Alerts: {
      noAlerts: '알림 없음',
      healthAndSafetyInformationMissing: '건강 및 안전 정보 누락',
      jobNotReleased: '작업이 해제되지 않았습니다',
      noRecentStatusChange: '최근 상태 변경이 없습니다.',
      noServiceTechnicalSupportInvolvement: '서비스 기술 지원이 필요하지 않습니다',
      noProductCompanyTechnicalSupportInvolvement: '제품 회사의 기술 지원이 필요하지 않습니다',
      noTechnicalWarrantyDecision: '기술 보증 결정 없음',
      noCommercialDecision: '상업적 결정이 없음',
      reportNotApproved: '승인되지 않은 보고서',
    },
    Actions: {
      ADD_JOB: '작업 추가',
      IMPORT_JOB: 'SAP에서 가져온 작업',
      DELETE_JOB: '삭제 된 작업',
      VERIFY_JOB: '검증된 작업',
      SET_PRICE: '편집 된 작업-가격',
      ADD_TEAM_MEMBER: '팀원 추가',
      REMOVE_TEAM_MEMBER: '팀원 삭제',
      REQUEST_REPORT_LEVEL_CHANGE: '요청 된 보고서 레벨 변경',
      APPROVE_REPORT_LEVEL_CHANGE: '승인 된 보고서 레벨 변경',
      DENY_REPORT_LEVEL_CHANGE: '거부 된 보고서 레벨 변경',
      REQUEST_REPORT_APPROVAL: '요청 된 보고서 승인',
      APPROVE_REPORT_APPROVAL: '승인 된 보고서 승인',
      DENY_REPORT_APPROVAL: '거부 된 보고서 승인',
      SET_WARRANTY_START_DATE: '편집 된 작업-보증 시작 날짜',
      SET_WARRANTY_END_DATE: '편집 된 작업-보증 종료 날짜',
      EQUIPMENT_SERIAL_NUMBER_EDITED: '편집 된 작업-장비 일련 번호',
      MATERIAL_NUMBER_EDITED: '편집 된 작업-자재 번호',
      WORKED_ON_JOB: '편집 된 작업-업데이트 양식',
      UPLOADED_FILE_ON_JOB: '편집 된 작업-파일 업로드',
      REQUEST_TECHNICAL_WARRANTY_DECISION: '요청 된 기술 보증 결정',
      APPROVE_TECHNICAL_WARRANTY_DECISION: '승인 된 기술 보증 결정',
      DENY_TECHNICAL_WARRANTY_DECISION: '거부 된 기술 보증 결정',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: '승인 된 상용 보증 결정',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: '무효화 된 상업용 보증 결정',
      DENY_COMMERCIAL_WARRANTY_DECISION: '상업적 보증 결정 거부',
      SEND_COMMENT: '댓글 추가',
      REOPEN_REPORT: '편집 된 작업-보고서 다시 열기',
      AWAITING_EQUIPMENT_STATUS_SET: '편집 된 상태-장비 설정 대기 중',
      AWAITING_EQUIPMENT_STATUS_RESET: '편집 된 상태-장비 재설정 대기 중',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: '편집 된 상태-문서 설정로 입고 된 장비',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: '편집 된 상태-문서 재설정으로 입고 된 장비',
      JOB_RELEASED_STATUS_SET: '편집 된 상태-작업 해제 설정',
      JOB_RELEASED_STATUS_RESET: '편집 된 상태-작업 해제 재설정',
      PRODUCT_EVALUATION_STATUS_SET: '편집 된 상태-제품 평가 설정',
      PRODUCT_EVALUATION_STATUS_RESET: '편집 된 상태-제품 평가 재설정',
      PRODUCT_INVESTIGATION_STATUS_SET: '편집 된 상태-제품 조사 설정',
      PRODUCT_INVESTIGATION_STATUS_RESET: '수정 된 상태-제품 조사 재설정',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: '편집 된 상태-탈지 및 오염 제거 설정',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: '편집 된 상태-제거 및 오염 제거 재설정',
      BUILT_AND_TESTED_STATUS_SET: '편집 된 상태-빌드 및 테스트 설정',
      BUILT_AND_TESTED_STATUS_RESET: '편집 된 상태-빌드 및 테스트 재설정',
      SHIPPED_STATUS_SET: '편집 된 상태-배송 설정',
      SHIPPED_STATUS_RESET: '편집 된 상태-배송 된 재설정',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: '편집 된 상태-기술 및 상업적 의사 결정 설정',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: '편집 된 상태-기술 및 상업적 의사 결정 재설정',
      FINAL_REPORT_RELEASED_STATUS_SET: '편집 된 상태-최종 보고서 공개 설정',
      FINAL_REPORT_RELEASED_STATUS_RESET: '편집 된 상태-최종 보고서 공개 재설정',
      CLOSED_STATUS_SET: '편집 된 상태-닫힌 설정',
      CLOSED_STATUS_RESET: '편집 된 상태-닫힌 재설정',
      CUSTOMER_HOLD_STATUS_SET: '편집 된 상태-고객 보류 설정',
      CUSTOMER_HOLD_STATUS_RESET: '편집 된 상태-고객 보류 재설정',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: '기술적 의사 결정 카테고리 편집',
      GENERATE_ALERT: '생성된 경고',
      INITIAL_WARRANTY_CODE_EDITED: '최초 보증 코드가 변경됨',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision KO',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision KO',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision KO',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision KO',
      CHOOSE_RELEASE_METHOD: 'Chose release method KO',
    },
    TechnicalWarranty: {
      ACCEPTED: '인정됨',
      DENIED: '거부됨',
      AGREE: '동의하다',
      DISAGREE: '동의하지 않는다',
      MANUFACTURING: '조작',
      DESIGN: '디자인',
      VENDOR: '공급 업체',
      PROCESS: '방법',
      INHOUSE_REPAIR: '사내 수리',
      FIELD_SERVICE_REPAIR: '현장 서비스 수리',
      NO_FAULT_FOUND: '결함이 없습니다',
      WARRANTY_EXPIRED: '보증 만료',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
      WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
      CUSTOMER_FAULT: '고객 결함',
      OTHER: '다른',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: '기술적 결정에 동의',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: '기술적 결정에 동의하지 않음',
      SPARE_PART: 'Spare part (Service Division) KO',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: '계약상의 협의 결정',
      GOODWILL_ACCEPTED: '영업권 허용',
      CHARGEABLE_TO_CUSTOMER: '고객에게 청구 가능',
      EXTENDED_WARRANTY: '연장 된 보증',
      SERVICE_CONTRACT: '서비스 계약',
      OTHER: '다른',
      SEMICONDUCTOR: '반도체',
      SCIENTIFIC: '과학O',
      INDUSTRIAL: '산업',
      SEMICONDUCTOR_SERVICE: '반도체 서비스',
      VACUUM_TECHNIQUE_SERVICE: '진공 기술 서비스',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: '반도체 챔버 솔루션',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: '기술팀이 참여하지 않음',
      GOLDENEYE_UPLINK: 'GoldenEye 업 링크',
      ON_SITE_PRESENCE: '현장 존재',
      RETURN_TO_PRODUCT_COMPANY: '제품 회사로 돌아 가기',
      SEND_BACK_PARTS: '부품 보내기',
    },
    Forms: {
      fields: {
        basicInformation: '기본 정보',
        customerCenter: '고객 센터',
        serviceTechnologyCenter: '서비스 기술 센터',
        reportLevel: '보고서 수준',
        initialWarrantyCode: '초기 보증',
        technicalDecision: '기술적 결정',
        commercialDecision: '상업적 결정',
        price: '가격',
        jobStatus: '직위',
        reportCompletion: '보고서 작성',
        alerts: '알림',
        team: '팀',
        customer: '고객',
        customerContact: '고객 연락처',
        jobDetails: '직업 세부 사항',
        jobType: '직종',
        serviceProduct: '서비스 제품',
        equipment: '장비',
        failure: '실패',
        symptom: '징후',
        address: '주소',
        contactPerson: '담당자',
        email: '이메일',
        phone: '전화',
        customerPurchaseOrderNumber: '고객 구매 주문 번호',
        equipmentWarranty: '장비 보증',
        serviceWarranty: '서비스 보증',
        reportStatus: '보고서 상태',
        reopen: '다시 열다',
        releaseJob: '작업 해제',
        notifyTeam: 'Notify team KO',
      },
      errors: {
        required: '필드는 필수입니다',
        phone: '유효한 전화 번호를 입력하세요',
        email: '유효한 이메일을 입력하십시오',
        number: '숫자 만 허용됩니다',
        alphanumeric: '특수 문자는 허용되지 않습니다',
        text: '유효한 값을 입력하십시오',
        unknown: '문제가 발생했습니다',
        belowZero: '값보다 작을 수 없습니다 0. KO',
        uploadFailed: '업로드하지 못했습니다',
        maxFileSize: '허용되는 최대 크기는',
        maxLength: maxLength => `Max ${maxLength} characters allowed KO`, // MISSING IN TRANSLATIONS MATERIAL
        minLength: minLength => `Please enter at least ${minLength} characters KO`, // MISSING IN TRANSLATIONS MATERIAL
      },
    },
    FaultCodes: {
      fallbackDescription: '이 코드에 대한 설명이 없습니다',
      jobTypeDescription: {
        'JT001': '작업 유형 JT에 대한 설명',
        'JT002': '작업 유형 JT에 대한 설명',
      },
      faultCodeDescription: {
        'FC001': '결함 코드 FC에 대한 설명',
        'FC002': '결함 코드 FC에 대한 설명',
      },
      symptomCodeDescription: {
        'SC001': '증상 코드 SC에 대한 설명',
        'SC002': '증상 코드 FC에 대한 설명',
      },
    },
    Progress: {
      title: '진행',
      productReceived: '받은 제품',
      productEvaluation: '제품 평가',
      stripObservation: '스트립 관찰',
      technicalInvestigation: '기술 조사',
      conformityTest: '적합성 테스트',
    },
  },
  Profile: {
    title: '프로필',
    name: '이름',
    role: '역할',
    company: '회사',
    rights: '진상',
    linked: '사용자가',
  },
  Jobs: {
    title: '일',
    filters: '필터',
    myJobs: '내 일',
    otherJobs: '다른 일',
    noJobsToDisplay: '표시 할 작업이 없습니다',
    pleaseUseTheSearchBar: "Please use the search bar. KO",
    id: '아이디',
    createdAt: '에 작성',
    status: '상태',
    customer: '고객',
    serialProductNumber: '제품 일련 번호',
    materialNumber: '재료 번호',
    equipmentSerialNumber: '장비 일련 번호',
    customerCenterPlantCode: 'CC 공장 코드',
    serviceTechnologyCenterPlannerGroup: 'STC 플래너 그룹',
    handledBy: '에 의해 처리',
    materialDescription: '재료설명',
    customerName: '고객 이름',
    receivedDate: '입고일자',
    customerCenterName: 'CC 이름',
    reportLevel: '보고서 수준',
    productReceived: '받은 제품',
    productEvaluation: '제품 평가',
    stripObservation: '스트립 관찰',
    technicalInvestigation: '기술 조사',
    conformityTest: '적합성 테스트',
    workFlow: '작업 흐름',
    analysisFlow: '분석 흐름',
    notificationNumber: '통지 번호',
    serviceOrderNumber: '서비스 주문 번호',
  },
  Job: {
    editButton: '편집',
    progress: '진행',
  },
  Filters: {
    filtersTitle: '필터',
    applyButton: '적용 버튼',
    clearButton: '지우기 버튼',
    sorting: '정렬',
    sortNew: '최신 정렬',
    sortOld: '가장 오래된 정렬',
    date: '날짜',
    dateFrom: '에서',
    dateTo: '에',
    reportLevel: '보고서 수준',
    status: '상태',
    customerNumber: '고객 번호',
    customerName: '고객 이름',
    serviceProductNumber: '서비스 제품 번호',
    materialNumber: '자재 번호',
    equipmentSerialNumber: '장비 일련 번호',
    stcPlannerGroup: 'STC 플래너 그룹',
    selectstcPlannerGroup: 'STC 플래너 그룹 선택',
    CCplant: 'CC 공장',
    selectCCplant: 'CC 공장 선택',
    distributor: '유통 업체',
    selectDistributor: '유통 업체 선택',
    failureAnalysisEngineerNotAssigned: '고장 분석 엔지니어에게 할당되지 않음',
    openedJobs: '채용 공고',
    publishedJobs: '게시 된 작업',
    pendingMyApproval: '승인 대기 중',
    notificationNumber: '통지 번호',
    unreadMessages: '읽지 않은 메시지',
    serviceOrderNumber: '서비스 주문 번호',
  },
  AddJob: {
    formSections: {
      title: '새 작업 추가',
      createdAt: '제작 일',
      button: '저장',
      basicInformation: {
        title: '기본 정보',
        fieldLabels: {
          equipmentSerialNumber: '장비 일련 번호',
          serviceTechnologyCenter: '서비스 기술 센터',
          customerCenter: '고객 센터',
          reportLevel: '보고서 수준',
          initialWarrantyCode: '초기 보증',
          customerPurchaseOrderNumber: '고객 구매 주문 번호',
          responsibleSalesPerson: '책임있는 영업 사원',
          customerCenterContactName: '고객 센터 담당자 이름',
          customerCenterContactEmail: '고객 센터 담당자 이메일',
        }
      },
      jobType: {
        title: '유형',
        fieldLabels: {
          jobType: '유형',
          jobTypeDescription: '기술',
        },
      },
      searchMaterialNumber: '검색 자료 번호',
      materialNumber: {
        title: '자재 번호',
        fieldLabels: {
          materialNumber: '자재 번호',
          materialNumberDescription: '기술',
        },
      },
      serviceProductNumber: {
        title: '서비스 제품 번호',
        fieldLabels: {
          serviceProductNumber: '서비스 제품 번호',
          serviceProductNumberDescription: '기술',
        },
      },
      symptomCode: {
        title: '증상 코드',
        fieldLabels: {
          scGroups: '증상 코드 그룹',
          symptomCode: '증상 코드',
          symptomCodeDescription: '기술',
        },
      },
      faultCode: {
        title: '고장 코드',
        fieldLabels: {
          fcGroups: '결함 코드 그룹',
          faultCode: '고장 코드',
          faultCodeDescription: '기술',
        },
      },
      customerInformation: {
        title: '고객 정보',
        fieldLabels: {
          customerId: '고객 ID',
          customerName: '이름',
          customerAddress: '주소',
          customerContact: '담당자',
          customerEmail: '이메일 주소',
          customerPhone: '전화 번호',
        },
      },
    },
  },
  ImportJob: {
    title: '가져온 작업',
    date: '가져온 날짜',
    importButton: '가져 오기 버튼',
    searchTitle: '기져올 작업 검색',
    searchSubtitle: '최소 5 자, 선행 제로 없음',
    searchButton: '검색',
    notificationNumberLabel: '통지 번호',
    serviceOrderNumberLabel: '서비스 주문 번호',
    linkTo: '다음으로 연결',
    openJobsFoundForSerNumber: '이 일련 번호에 대한 열린 작업',
    importJobAsNew: '새로운 직업을 가져 오기',
    jobIsImportedAlready: '작업을 이미 가져 왔습니다',
    importing: 'Importing in progress... KO',
    linking: 'Linking in progress... KO',
    columns: {
      sourceId: '소스 ID',
      notificationNumber: '통지 번호',
      serviceOrderNumber: '서비스 주문 번호',
      serialNumber: '일련 번호',
      jobTypeDescription: '기술',
      customerName: '고객 이름',
    },
  },
  SingleJob: {
    title: '작업',
    createdAt: '에 작성',
    modifiedAt: '에 마지막 수정',
    serviceOrderNumber: '서비스 주문 번호',
    notificationNumber: '통지 번호',
    receivedProduct: '받은 제품',
    productEvaluation: '제품 평가',
    stripObservation: '스트립 관찰',
    technicalInvestigation: '기술 조사',
    conformityTest: '적합성 테스트',
    log: '로그',
    conversation: '대화',
    noTechPossibilityParagraph1: '이 STC에는이 작업에 대한 테스트 용량이 없습니다',
    noTechPossibilityParagraph2: '작업을 닫고 펌프를 다른 STC로 보내십시오.',
    downloadPictures: '사진 다운로드',
    downloadAllPictures: '모든 사진 다운로드',
    downloadPicturesFrom: '에서 사진 다운로드',
    downloadInProgressPleaseWait: 'Download in progress... Please wait KO',
  },
  JobSummary: {
    title: '작업 요약',
    createdAt: '생성일',
    modifiedAt: '마지막 수정일',
    reportLevelDialogTitle: '보고서 레벨',
    reportLevelDialogContent: '요청 된 보고서 레벨 설정',
    reportLevelDialogInitialWarrantyCodeLabel: '초기 보증',
    approveReportLevelDialogTitle: '보고서 수준 요청 승인',
    technicalWarrantyDialogTitle: '기술적 결정 제안',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal KO',
    technicalWarrantyDialogContent: '보증 결정',
    technicalWarrantyDialogCategory: '보증 카테고리',
    rateTechnicalDecisionTitle: '기술 결정 평가',
    rate: '율',
    reclassify: 'Reclassify KO',
    rateTechnicalDecisionComment: '기술 결정 등급에 대한 의견',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: '기술 보증 제안 승인',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: '기술 결정 범주 재 분류',
    commercialDecisionDialogTitle: '상업적 결정 제안',
    commercialDecisionDialogContent: '보증 결정',
    commercialDecisionDialogCategory: '보증 카테고리',
    approveCommercialDecisionDialogTitle: '제안서 승인',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision KO',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision KO',
    editPriceDialogTitle: '가격 수정',
    editPriceLabel: '편집',
    releaseJobDialogTitle: '해고 직업',
    releaseJobDialogLabel: '방법 선택',
    proposedDate: '제안 된 날짜',
    reportStatusDialogTitle: '보고서 상태 제안',
    reportStatusDialogContent: '이것은 보고서 승인을 요청합니다',
    approveReportStatusDialogContent: '이 직업을 다시 열겠습니까?',
    chooseReleaseJobMethodTitle: '릴리스 작업 방법을 선택하십시오',
    editChosenReleaseJobMethodTitle: '선택한 릴리즈 작업 방법 편집',
    approveReportStatusDialogTitle: '상태보고',
    editJobStatusDialogTitle: '작업 상태 편집',
    editEquipmentSerialNumberDialogTitle: '장비 일련 번호 편집',
    editEquipmentSerialNumberDialogFieldLabel: '장비 일련 번호',
    editMaterialNumberDialogTitle: '자재 번호 편집',
    editMaterialNumberDialogFieldLabel: '자재 번호',
    editMaterialNumberDialogDescriptionFieldLabel: '기술',
    warrantyStartDialogTitle: '보증 시작일 편집',
    warrantyStartDateLabel: '보증 시작일',
    warrantyEndDialogTitle: '보증 종료일 편집',
    warrantyEndDateLabel: '보증 종료일',
    verifyJobDialogTitle: '작업 확인',
    verifyJobDialogContent: '이 작업은 편집을 위해 재료 및 장비 번호를 잠급니다. 다음 데이터가 정확한지 확인하십시오',
    materialNumber: '자재 번호',
    equipmentSerialNumber: '장비 일련 번호',
    deleteConfirmationDialogTitle: '확인 필요',
    deleteConfirmationDialogContent: '이 작업을 삭제 하시겠습니까?',
    teamDialogTitle: '팀원 추가',
    removeTeamMemberDialogTitle: '팀원 제거',
    removeTeamMemberDialogContent: '이 멤버를 팀에서 제거 하시겠습니까?',
    technicalDecisionReason: '기술적 결정 사유',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    decisionReason: '결정 사유',
    commercialDecisionReason: '상업적 결정 사유',
    changeReportLevelReason: '보고서 수준 변경 이유',
    approveReportLevelDialogRequestedLevel: '요청 된 레벨',
    approveReportLevelDialogPreviousLevel: '이전 레벨',
    approveReportLevelDialogInitialWarrantyCode: '초기 보증',
    initialWarrantyCode: '초기 보증',
    shipToAddress: '배송지',
    partNumbers: '부품 번호',
    failureReason: '실패 이유',
    symptomReason: '증상사유',
    chooseMethod: '방법을 선택하십시오',
    chosenMethod: '선택된 방법',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add. KO',
    deleteImportedJob: 'Delete imported KO',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? KO',
  },
  LogSection: {
    title: '로그',
    sib: 'SIB',
    initialWarrantyCode: '초기 보증',
  },
  ReportsDialog: {
    title: '보고서 생성',
    confirmButton: '생성하다',
    reportFormat: '보고서 형식',
    reportTemplate: '보고서 템플릿',
  },
  ActionMode: {
    takePicture: '사진을 찍다',
    takeStandardPicture: '표준 사진 찍기',
    takeNonStandardPicture: '비표준 사진 촬영',
    lastScreenMessage: '이 섹션의 끝에 도달했습니다. 이 창을 닫아주세요',
    lastScreenMessageUnsavedAnswers: '이 섹션의 끝에 도달했습니다. 답변을 저장하십시오'
  },
  InputFile: {
    special: '특별한',
    upload: '업로드',
    uploadStandardPicture: '표준 사진 업로드',
    uploadNonStandardPicture: '비표준 사진 업로드',
    commentPicture: '댓글 사진',
    confirmButtonText: '댓글 저장',
    moveFileModal: {
      title: '파일 이동',
      confirmButtonText: '움직임',
      selectSubsection: '서브 섹션 선택',
      selectQuestion: '질문을 선택하십시오',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: '움직임',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/ko.js